import { render, staticRenderFns } from "./DiffPourcentage.vue?vue&type=template&id=1890d00d&"
import script from "./DiffPourcentage.vue?vue&type=script&lang=js&"
export * from "./DiffPourcentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports